"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TripsListController_1 = require("./TripsListController");
exports.TripsListController = TripsListController_1.TripsListController;
var TripsEditController_1 = require("./TripsEditController");
exports.TripsEditController = TripsEditController_1.TripsEditController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/controllers/index.ts
// module id = 561
// module chunks = 0